'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Front = _interopRequireDefault(require("Layouts/Front"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _Logo = _interopRequireDefault(require("Pure/Logo"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Routes = require("Shared/Routes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
let app = window.app;
class NotAllowedPage extends _react.Component {
  state = {
    roles: []
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.push({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
    if (app.state.session?.user?.id) {
      component.handleSessionChange({
        source: 'DidMount'
      });
    }
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
  }
  handleSessionChange = ({
    source,
    data
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      roles: app.state.session.user.roles
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)({
      error: app.state.form_error
    });
    const default_error = state.roles.length === 0 ? 'Connectez-vous pour accéder à cette page' : 'Vous n\'avez pas la permission d\'accéder à cette page.';
    let output = /*#__PURE__*/_react.default.createElement(_Front.default, _extends({
      page_title: "Acc\xE8s refus\xE9"
    }, props), /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width"
    }, /*#__PURE__*/_react.default.createElement("h1", {
      className: "login-page__title"
    }, "Acc\xE8s refus\xE9"), /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: "auth-logo-link",
      href: (0, _Routes.URL)('Home', _Routes.front_urls)
    }, /*#__PURE__*/_react.default.createElement(_Logo.default, {
      style: {
        width: '240px',
        maxWidth: '100%',
        margin: 'auto'
      }
    })), status.length === 0 ? (0, _getFormStatus.default)({
      error: default_error
    }) : status, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25\r u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "secondary",
      size: "small",
      href: state.roles.length === 0 ? (0, _Routes.URL)('Home', _Routes.front_urls) : (0, _Routes.URL)('Home', _Routes.front_urls),
      component: props => /*#__PURE__*/_react.default.createElement(_Link.default, props)
    }, "Retour a l\\'accueil"))));
    return output;
  }
}
exports.default = NotAllowedPage;
